/* eslint-disable */
import * as Blockly from 'blockly';


class Drawer extends Blockly.blockRendering.Drawer {
  constructor(block, info) {
    super(block, info);
    // console.log('================Drawer', block, this);

    // Los bloques de output sin conexiones de statement (math_whole_number) son cápsulas
    // de radio alto/2, no el radio fijo 33 del bloque de Inicio, que no se toca.
    this.isOutputOnlyRound_ = !!(block.outputConnection && !info.previousConnection && !info.nextConnection);
  }

  // Ajustes del shadow chico, después de super.draw() porque recién ahí el layout del
  // field está listo: el borde #3373CC de prod (updateShadow_ de v13 fuerza stroke:none en
  // todo shadow) y el número recentrado (FieldNumber se posiciona con padding fijo).
  draw() {
    super.draw();
    if (!this.isOutputOnlyRound_) {
      // El óvalo shadow conectado se recentra desde el padre: ver centerRoundShadowInputs_.
      this.centerRoundShadowInputs_();
      return;
    }

    const svgRoot = this.block_.getSvgRoot();
    if (!svgRoot) return;

    const outlinePath = svgRoot.querySelector(':scope > path.blocklyPath');
    if (outlinePath) {
      outlinePath.setAttribute('stroke', '#3373CC');
      // Blockly repinta el shadow más tarde (p. ej. al deshabilitar un bloque suelto) y
      // vuelve a forzar stroke="none": el MutationObserver lo reaplica. La marca en el
      // dataset evita apilar un observer por re-render.
      if (!outlinePath.dataset.rb123StrokeObserver) {
        outlinePath.dataset.rb123StrokeObserver = '1';
        const keepStroke = () => {
          if (outlinePath.getAttribute('stroke') !== '#3373CC') {
            outlinePath.setAttribute('stroke', '#3373CC');
          }
        };
        new MutationObserver(keepStroke).observe(outlinePath, { attributes: true, attributeFilter: ['stroke'] });
      }
    }

    const fieldGroup = svgRoot.querySelector('.blocklyEditableField');
    const fieldRect = fieldGroup && fieldGroup.querySelector('rect.blocklyFieldRect');
    if (fieldGroup && fieldRect) {
      const fieldWidth = parseFloat(fieldRect.getAttribute('width')) || 0;
      const blockWidth = this.info_.width;
      const centeredX = (blockWidth - fieldWidth) / 2;
      // fieldRect mide lo mismo que la cápsula (FIELD_BORDER_RECT_HEIGHT, forzado en
      // info.js), así que y=0 la centra; la y estándar de Blockly la corre 7px abajo.
      fieldGroup.setAttribute('transform', `translate(${centeredX}, 0)`);

      // Blockly deja el <text> alineado a la izquierda dentro del rect: se centra también,
      // como el <text text-anchor="middle"> de prod.
      const text = fieldGroup.querySelector('text.blocklyFieldText');
      if (text) {
        const rectX = parseFloat(fieldRect.getAttribute('x')) || 0;
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('x', String(rectX + fieldWidth / 2));
      }
    }
  }

  // Centra el óvalo shadow conectado midiendo el getBBox() real de los dos contornos: los
  // anchos nominales (info_.width) no coinciden con lo pintado. Tiene que correr en el
  // draw() del PADRE, después de super.draw(): positionInlineInputConnection_ fija el
  // offset (8,56) y pisaría un recentrado hecho antes desde el propio shadow.
  centerRoundShadowInputs_() {
    const svgRoot = this.block_.getSvgRoot();
    if (!svgRoot) return;
    const parentOutline = svgRoot.querySelector(':scope > path.blocklyPath');
    if (!parentOutline) return;
    const parentBBox = parentOutline.getBBox();
    const parentCenterX = parentBBox.x + parentBBox.width / 2;

    for (const input of this.block_.inputList) {
      const target = input.connection && input.connection.targetBlock();
      const isRoundOutput = target
        && target.outputConnection && !target.previousConnection && !target.nextConnection;
      if (!isRoundOutput) continue;

      const targetSvgRoot = target.getSvgRoot();
      const targetOutline = targetSvgRoot
        && targetSvgRoot.querySelector(':scope > path.blocklyPath');
      if (!targetOutline) continue;

      const shadowBBox = targetOutline.getBBox();
      const shadowOffsetX = parentCenterX - (shadowBBox.x + shadowBBox.width / 2);
      // y fijo en 56, igual que positionInlineInputConnection_: el transform del hijo no
      // siempre tiene ya el valor esperado (p. ej. recién conectado y deshabilitado).
      const y = 56;

      // Se mueve el connection model y no el transform del DOM: Blockly resincroniza la
      // posición del hijo desde input.connection en un paso posterior del render.
      input.connection.setOffsetInBlock(shadowOffsetX, y);
      targetSvgRoot.setAttribute('transform', `translate(${shadowOffsetX}, ${y})`);
    }
  }

  getFullRadiusLength_() {
    return this.isOutputOnlyRound_
      ? this.info_.height / 2
      : this.constants_.OUTSIDE_CORNERS.fullRadiusLength;
  }

  getTopLeftFullRadius_() {
    if (!this.isOutputOnlyRound_) return this.constants_.OUTSIDE_CORNERS.topLeftFullRadius;
    const r = this.info_.height / 2;
    return Blockly.utils.svgPaths.moveBy(0, r)
      + Blockly.utils.svgPaths.arc('a', '0 0,1', r, Blockly.utils.svgPaths.point(r, -r));
  }

  getBottomLeftFullRadius_() {
    if (!this.isOutputOnlyRound_) return this.constants_.OUTSIDE_CORNERS.bottomLeftFullRadius;
    const r = this.info_.height / 2;
    return Blockly.utils.svgPaths.arc('a', '0 0,1', r, Blockly.utils.svgPaths.point(-r, -r));
  }

  drawOutline_() {
    // console.log('================drawOutline_', this.info_.rows);
    if (this.isOutputOnlyRound_) {
      // Path de cápsula armado directo con el alto y ancho finales: drawTop_/drawRight_/...
      // suman alturas de fila, no info_.height, y el cuerpo quedaría más alto que el radio.
      const r = this.info_.height / 2;
      const w = this.info_.width;
      this.outlinePath_ =
        `m ${r},0 `
        + `a ${r},${r} 0 0,0 ${-r},${r} `
        + `a ${r},${r} 0 0,0 ${r},${r} `
        + `h ${w - 2 * r} `
        + `a ${r},${r} 0 0,0 ${r},${-r} `
        + `a ${r},${r} 0 0,0 ${-r},${-r} `
        + 'z';
      return;
    }
    this.drawTop_();
    this.drawRight_(this.info_.rows[2]);
    this.drawBottom_();
    this.drawLeft_(this.info_.rows[2]);
  }

  // En prod un value input de BHOOT_motor_* nunca talla muesca en el contorno. El
  // drawInlineInput_ base deja un subpath degenerado que el stroke igual marca, así que no
  // se llama: solo se reposiciona la conexión.
  drawInlineInput_(input) {
    this.positionInlineInputConnection_(input);
  }

  // El shadow conectado cuelga debajo del ícono en un offset fijo (8,56), como en el
  // legacy: 56 = 12 + 40 del ícono + 4 de aire; revisarlo si se agrega un bloque con otro
  // ícono. El <g> del shadow está anidado en el del padre, así que es un offset LOCAL:
  // alcanza con setOffsetInBlock, sin sumar la posición del padre ni observers en el DOM.
  positionInlineInputConnection_(input) {
    if (!input.connectionModel) return;
    const x = this.info_.RTL ? -8 : 8;
    input.connectionModel.setOffsetInBlock(x, 56);
  }

  drawRight_(row) {
    var nextConnection = this.info_.nextConnection;
    if (nextConnection) {
      var extraHeight = row.height - nextConnection.height;
      this.outlinePath_ +=
        Blockly.utils.svgPaths.lineOnAxis('V', extraHeight) +
        nextConnection.shape.pathRight +
        Blockly.utils.svgPaths.lineOnAxis('v', 5);
      var connInfo = nextConnection;
      var x = connInfo.xPos + this.constants_.CORNER_RADIUS;
      // var x = connInfo.xPos;
      // var x = connInfo.xPos - connInfo.width;
      var connX = (this.info_.RTL ? -x : x);
      var connY = row.height - nextConnection.height - 1;
      connInfo.connectionModel.setOffsetInBlock(connX, connY);
      // console.log('========================connInfo drawRight_', row, nextConnection);
      // connInfo.connectionModel.setOffsetInBlock(connX, (connInfo.centerline - connInfo.height / 2));
    }
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('V', row.yPos + row.height - this.constants_.CORNER_RADIUS);
    // this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('V', row.height);
  }

  drawLeft_(row) {
    var previousConnection = this.info_.previousConnection;
    // console.log('================drawLeft_', row, previousConnection, this);
    if (previousConnection) {
      var up = 5 + this.constants_.CORNER_RADIUS;
      var extraHeight = row.height - previousConnection.height - up;
      this.outlinePath_ +=
        Blockly.utils.svgPaths.lineOnAxis('v', -up) +
        previousConnection.shape.pathLeft +
        Blockly.utils.svgPaths.lineOnAxis('v', -extraHeight);

      var connInfo = previousConnection;
      var x = connInfo.xPos;
      var connX = (this.info_.RTL ? -x : x);
      var connY = row.height - previousConnection.height - 1;
      connInfo.connectionModel.setOffsetInBlock(connX, connY);
      // connInfo.connectionModel.setOffsetInBlock(connX, (connInfo.centerline - connInfo.height / 3));
    }
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('V', this.constants_.CORNER_RADIUS + (!this.info_.previousConnection ? this.getFullRadiusLength_() - this.constants_.CORNER_RADIUS : 0));
    // this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('V', row.height);
  }


  drawTop_() {
    var topRow = this.info_.topRow;
    var elements = topRow.elements;

    this.outlinePath_ += Blockly.utils.svgPaths.moveBy(topRow.xPos, this.info_.startY);
    for (var i = 0, elem; (elem = elements[i]); i++) {
      if (Blockly.blockRendering.Types.isLeftRoundedCorner(elem)) {
        if (this.info_.previousConnection) {
          this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft;
        } else {
          this.outlinePath_ += this.getTopLeftFullRadius_();
        }
      } else if (Blockly.blockRendering.Types.isRightRoundedCorner(elem)) {
        this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight;
      } else if (Blockly.blockRendering.Types.isSpacer(elem)) {
        // let width = elem.width;
        if (this.info_.rows[2].hasStatement) {
          const row = this.info_.rows[2];
          // console.log('================drawTop_', elem, elements, row);
          this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('h', row.widthWithConnectedBlocks);
        } else {
          // this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('h', elem.width);
          const horizontal = elem.xPos + elem.width - (!this.info_.previousConnection ? this.getFullRadiusLength_() - this.constants_.CORNER_RADIUS: 0);
          this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('h', horizontal);
        }
      }
      // No branch for a square corner because it's a no-op.
    }
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('v', topRow.height);
  }

  drawBottom_() {
    var bottomRow = this.info_.bottomRow;
    var elems = bottomRow.elements;

    var outlinePath = '';
    for (var i = elems.length - 1, elem; (elem = elems[i]); i--) {
      if (Blockly.blockRendering.Types.isLeftRoundedCorner(elem)) {
        if (this.info_.previousConnection) {
          outlinePath += this.constants_.OUTSIDE_CORNERS.bottomLeft;
        } else {
          outlinePath += this.getBottomLeftFullRadius_();
        }
      } else if (Blockly.blockRendering.Types.isRightRoundedCorner(elem)) {
        outlinePath += this.constants_.OUTSIDE_CORNERS.bottomRight;
      } else if (Blockly.blockRendering.Types.isSpacer(elem)) {
        if (this.info_.rows[2].hasStatement) {
          outlinePath += this.drawStatementInput_(this.info_.rows[2]);
        } else {
          // outlinePath += Blockly.utils.svgPaths.lineOnAxis('h', -1 * elem.width);}
          const horizontal = elem.xPos + elem.width - (!this.info_.previousConnection ? this.getFullRadiusLength_() - this.constants_.CORNER_RADIUS : 0);
          outlinePath += Blockly.utils.svgPaths.lineOnAxis('h', -1 * horizontal);
        }
      }
    }

    const vertical = bottomRow.yPos - (this.constants_.CORNER_RADIUS / 2);
    this.outlinePath_ += Blockly.utils.svgPaths.lineOnAxis('V', vertical);
    this.outlinePath_ += outlinePath;
  }

  getLastInput(row) {
    // TODO: Consider moving this to InputRow, if possible.
    for (let i = row.elements.length - 1; i >= 0; i--) {
      const elem = row.elements[i];
      // if (Blockly.blockRendering.Types.isInput(elem)) {
      if (Blockly.blockRendering.Types.isStatementInput(elem)) {
        return elem;
      }
    }
    return null;
  }

  drawStatementInput_(row) {
    const input = this.getLastInput(row);
    // Where to start drawing the notch, which is on the right side in LTR.
    const insideCorners = this.constants_.INSIDE_CORNERS;

    const statementWidthEmpty = this.constants_.EMPTY_STATEMENT_INPUT_WIDTH - 2 * this.constants_.CORNER_RADIUS;
    const statementWidth = Math.max(input.connectedBlockWidth - statementWidthEmpty - 2 * this.constants_.CORNER_RADIUS, statementWidthEmpty);
    const paddingLeft = input.shape.width;
    const paddingRight = row.widthWithConnectedBlocks - statementWidth - paddingLeft - (4 * this.constants_.CORNER_RADIUS);
    const notchPadding = 5 + this.constants_.CORNER_RADIUS;
    const extraHeight = Math.max(input.connectedBlockHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT + this.constants_.NOTCH_HEIGHT) - input.shape.height - 5 - this.constants_.NOTCH_HEIGHT;
    // console.log('================drawStatementInput_', input, row);
    const outlinePath_ =
      Blockly.utils.svgPaths.lineOnAxis('h', -paddingRight) +
      insideCorners.pathBottomRight +
      Blockly.utils.svgPaths.lineOnAxis('v', -notchPadding) +
      input.shape.pathLeft +
      Blockly.utils.svgPaths.lineOnAxis('v', -extraHeight) +
      insideCorners.pathTopRight +
      Blockly.utils.svgPaths.lineOnAxis('h', -statementWidth) +
      insideCorners.pathTopLeft +
      Blockly.utils.svgPaths.lineOnAxis('v', extraHeight) +
      input.shape.pathRight +
      Blockly.utils.svgPaths.lineOnAxis('v', notchPadding) +
      insideCorners.pathBottomLeft +
      Blockly.utils.svgPaths.lineOnAxis('h', -paddingLeft)
      ;

    // var up = 5 + this.constants_.CORNER_RADIUS;
    // var extraHeight = row.height - previousConnection.height - up;
    this.positionStatementInputConnection_(row);
    return outlinePath_;
  }

  layoutField_(fieldInfo) {
    const yPos = fieldInfo.centerline - fieldInfo.height / 2;
    let xPos = fieldInfo.xPos + (!this.info_.previousConnection ? 5 : 0);
    let scale = '';
    if (this.info_.RTL) {
      xPos = -(xPos + fieldInfo.width);
      if (fieldInfo.flipRtl) {
        xPos += fieldInfo.width;
        scale = 'scale(-1 1)';
      }
    }

    if (Blockly.blockRendering.Types.isIcon(fieldInfo)) {
      const icon = fieldInfo.icon;
      icon.setOffsetInBlock(new Coordinate(xPos, yPos));
      if (this.info_.isInsertionMarker) {
        icon.hideForInsertionMarker();
      }
    } else {
      const svgGroup = fieldInfo.field.getSvgRoot() || null;
      // console.log('================layoutField_', fieldInfo, this);
      svgGroup.setAttribute(
        'transform',
        'translate(' + xPos + ',' + yPos + ')' + scale,
      );
      // svgGroup.setAttribute('fill', '#000000');
      if (this.info_.isInsertionMarker) {
        svgGroup.setAttribute('display', 'none');
      }
    }
  }

  drawConnectionHighlightPath(measurable) {
    // leave this empty to avoid drawing the connection highlight path
  }
}

export default Drawer;
